// extracted by mini-css-extract-plugin
export default {"container":"category-menu_container__e-IjC","bottom-item":"category-menu_bottom-item__eLaLH"};